import { EProfileType } from '../entities/IGlobal';

export const resolvePickerProfileType = (type: unknown): EProfileType | undefined => {
    if (type === undefined || type === null || type === '') {
        return undefined;
    }

    const raw = String(type).toLowerCase();
    return (Object.values(EProfileType) as string[]).find(value => value === raw) as EProfileType | undefined;
};
